<template>
  <v-combobox
    v-model="template"
    label="Protocolo"
    dense
    outlined
    hide-details
    background-color="white"
    :items="templates"
    item-text="name"
    @change="activeTemplate"
    :disabled="attendanceEsigned"
    :style="{ width: '10rem' }"
  />
</template>

<script>
export default {
  name: "AttendanceTherapyProtocolForm",
  props: {
    attendance: Object,
    attendanceEsigned: Boolean,
  },
  data() {
    return {
      template: "",
    };
  },
  apollo: {
    templates: {
      query: require("@/graphql/template/templates.gql"),
      variables: {
        templateType: "attendance_therapy",
      },
    },
  },
  methods: {
    async activeTemplate() {
      if (this.attendanceEsigned) return;
      if (!this.template?.id) return;

      await this.apolloMutate({
        mutation: require("@/graphql/attendance/active_therapy_template.gql"),
        variables: {
          attendanceId: this.attendance.id,
          templateId: this.template.id,
        },
      });

      this.template = "";
    },
  },
};
</script>

<style lang="scss" scoped></style>
